export default function logSiteVisit(){
  global.apiRequest({
    url: `/user/logs/logvisit`,
    method: 'POST',
    body: {
      visitedAt: new Date().toString(),
    }
  })
}